import React, { FC } from "react";
import { IModule } from "../types";
import VerticalCardsPanel, { IVerticalCardsPanelProps } from "../../../components/panels/VerticalCardsPanel";

export type GetVerticalCardsPanelProps = IModule<IVerticalCardsPanelProps>;

export const getVerticalCardsPanel: FC<GetVerticalCardsPanelProps> = (props: GetVerticalCardsPanelProps) => {
  const {
    id, ...rest
  } = props;

  return (
    <VerticalCardsPanel
      key={id}
      {...rest}
    />
  );
};
